module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "components-container"
  }, [_c('div', {
    staticClass: "filter-container"
  }, [_c('el-select', {
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "placeholder": "学年"
    },
    on: {
      "change": _vm.handleFilter
    },
    model: {
      value: (_vm.queryForm.year),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "year", $$v)
      },
      expression: "queryForm.year"
    }
  }, _vm._l((_vm.comboOption.year), function(item, index) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "value": item.comboValue,
        "label": item.comboName
      }
    })
  }), 1), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "placeholder": "课程名称"
    },
    model: {
      value: (_vm.queryForm.courseName),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "courseName", $$v)
      },
      expression: "queryForm.courseName"
    }
  }), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "placeholder": "开课系部",
      "clearable": ""
    },
    model: {
      value: (_vm.queryForm.deptCode),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "deptCode", $$v)
      },
      expression: "queryForm.deptCode"
    }
  }, _vm._l((_vm.comboOption.courseDept), function(item, index) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "value": item.comboValue,
        "label": item.comboName
      }
    })
  }), 1), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "placeholder": "修读学期",
      "clearable": ""
    },
    model: {
      value: (_vm.queryForm.semesterNum),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "semesterNum", $$v)
      },
      expression: "queryForm.semesterNum"
    }
  }, _vm._l((_vm.comboOption.semesterNum), function(item, index) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "value": item.comboValue,
        "label": item.comboName
      }
    })
  }), 1), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "gray"
    },
    on: {
      "click": _vm.handleFilter
    }
  }, [_c('i', {
    staticClass: "el-icon-search"
  }), _vm._v(" 查询")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "gray"
    },
    on: {
      "click": _vm.handleReset
    }
  }, [_c('i', {
    staticClass: "el-icon-refresh"
  }), _vm._v(" 重置")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.addCourse
    }
  }, [_c('i', {
    staticClass: "el-icon-circle-plus-outline"
  }), _vm._v(" 添加")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.delCourse
    }
  }, [_c('i', {
    staticClass: "el-icon-delete"
  }), _vm._v(" 删除")])], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading.body",
      value: (_vm.tableLoading),
      expression: "tableLoading",
      modifiers: {
        "body": true
      }
    }],
    ref: "mainTable",
    attrs: {
      "data": _vm.tableData,
      "element-loading-text": "信息加载中",
      "stripe": "",
      "border": "",
      "fit": "",
      "highlight-current-row": "",
      "header-cell-class-name": "tableHeadStyle",
      "height": _vm.mainTableHeight
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "50",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "50",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.$index + 1))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "学年",
      "prop": "year",
      "width": "100px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "课程名称",
      "prop": "courseName",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "开课部门",
      "prop": "deptName",
      "width": "150px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "学分",
      "prop": "credit",
      "width": "50px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "修读学期",
      "prop": "semesterNum",
      "formatter": _vm.semesterNumFormatter,
      "width": "80px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "修读学时",
      "prop": "semesterLearnHour",
      "width": "50px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "设置专业",
      "prop": "majorNum",
      "width": "50px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "已用专业",
      "prop": "usedMajorNum",
      "width": "50px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "210px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "warning",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.modCourse(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-edit"
        }), _vm._v(" 编辑\n                ")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.majorConfig(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-setting"
        }), _vm._v(" 专业设置\n                ")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.dialogTitle,
      "visible": _vm.dialogVisible,
      "width": "800px",
      "top": "150px",
      "append-to-body": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      },
      "closed": _vm.closeDialog
    }
  }, [_c('el-form', {
    ref: "curdForm",
    attrs: {
      "model": _vm.curdForm,
      "label-width": "120px",
      "label-position": "left",
      "rules": _vm.curdFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "课程名称",
      "prop": "courseComboValue"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择",
      "filterable": ""
    },
    on: {
      "change": _vm.handleCourseChange
    },
    model: {
      value: (_vm.curdForm.courseComboValue),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "courseComboValue", $$v)
      },
      expression: "curdForm.courseComboValue"
    }
  }, _vm._l((_vm.comboOption.course), function(item, index) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "value": item.value,
        "label": item.label
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "学年",
      "prop": "year"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.curdForm.year),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "year", $$v)
      },
      expression: "curdForm.year"
    }
  }, _vm._l((_vm.comboOption.year), function(item, index) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "value": item.comboValue,
        "label": item.comboName
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "考核方式",
      "prop": "examTypeCode"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.curdForm.examTypeCode),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "examTypeCode", $$v)
      },
      expression: "curdForm.examTypeCode"
    }
  }, _vm._l((_vm.comboOption.examType), function(item, index) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "value": item.comboValue,
        "label": item.comboName
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "学分",
      "prop": "credit"
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "min": 0,
      "max": 999,
      "precision": 2,
      "step": 1,
      "label": "请输入学分"
    },
    model: {
      value: (_vm.curdForm.credit),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "credit", $$v)
      },
      expression: "curdForm.credit"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "总学时",
      "prop": "totalHour"
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "min": 0,
      "max": 999,
      "label": "请输入总学时"
    },
    model: {
      value: (_vm.curdForm.totalHour),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "totalHour", $$v)
      },
      expression: "curdForm.totalHour"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "理论学时",
      "prop": "theoryHour"
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "min": 0,
      "max": 999,
      "label": "请输入理论学时"
    },
    model: {
      value: (_vm.curdForm.theoryHour),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "theoryHour", $$v)
      },
      expression: "curdForm.theoryHour"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "实践学时",
      "prop": "trainingHour"
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "min": 0,
      "max": 999,
      "label": "请输入实践学时"
    },
    model: {
      value: (_vm.curdForm.trainingHour),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "trainingHour", $$v)
      },
      expression: "curdForm.trainingHour"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "修读学期",
      "prop": "semesterNum"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.curdForm.semesterNum),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "semesterNum", $$v)
      },
      expression: "curdForm.semesterNum"
    }
  }, _vm._l((_vm.comboOption.semesterNum), function(item, index) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "value": item.comboValue,
        "label": item.comboName
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "修读学时",
      "prop": "semesterLearnHour"
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "min": 0,
      "max": 999,
      "label": "请输入修读学时"
    },
    model: {
      value: (_vm.curdForm.semesterLearnHour),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "semesterLearnHour", $$v)
      },
      expression: "curdForm.semesterLearnHour"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveCourse
    }
  }, [_vm._v("确定")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v("取消")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "继承公共课设置",
      "visible": _vm.inheritCourseDialog,
      "width": "540px",
      "top": "20vh",
      "append-to-body": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.inheritCourseDialog = $event
      },
      "closed": _vm.closeInheritCourseDialog
    }
  }, [_c('el-form', {
    ref: "inheritForm",
    attrs: {
      "model": _vm.inheritForm,
      "label-width": "130px",
      "label-position": "left",
      "width": "100%"
    }
  }, [_c('el-row', [_c('el-form-item', {
    attrs: {
      "label": "被继承学年",
      "prop": "year"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "学年"
    },
    on: {
      "change": _vm.termChange
    },
    model: {
      value: (_vm.inheritForm.year),
      callback: function($$v) {
        _vm.$set(_vm.inheritForm, "year", $$v)
      },
      expression: "inheritForm.year"
    }
  }, _vm._l((_vm.comboOption.jcyear), function(item, index) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-form-item', {
    attrs: {
      "label": "所属部门",
      "prop": "courseDept"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "change": _vm.ssbmChange
    },
    model: {
      value: (_vm.inheritForm.courseDept),
      callback: function($$v) {
        _vm.$set(_vm.inheritForm, "courseDept", $$v)
      },
      expression: "inheritForm.courseDept"
    }
  }, _vm._l((_vm.comboOption.courseDept), function(item, index) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-form-item', {
    attrs: {
      "label": "公共课",
      "prop": "course"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "全部",
      "filterable": "",
      "multiple": "",
      "clearable": ""
    },
    model: {
      value: (_vm.inheritForm.course),
      callback: function($$v) {
        _vm.$set(_vm.inheritForm, "course", $$v)
      },
      expression: "inheritForm.course"
    }
  }, _vm._l((_vm.comboOption.courseInfo), function(item, index) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "value": item.comboValue,
        "label": item.comboName
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.inheritCourseSubmit
    }
  }, [_c('i', {
    staticClass: "el-icon-document"
  }, [_vm._v(" 确定")])]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.closeInheritCourseDialog
    }
  }, [_vm._v("取 消")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "专业设置",
      "visible": _vm.majorConfigDialogVisible,
      "width": "1200px",
      "top": "80px",
      "append-to-body": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.majorConfigDialogVisible = $event
      },
      "closed": _vm.queCourseList
    }
  }, [_c('div', {
    staticStyle: {
      "height": "600px"
    }
  }, [_c('majorConfig', {
    ref: "majorConfig",
    attrs: {
      "listHeight": 500
    }
  })], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2ffcfaf2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/teachingManage/teachingScheme/coursePreConfig.vue
// module id = 1803
// module chunks = 502